module.exports = __webpack_public_path__ + "img/paso1.4d27d5fa.png";